import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, Tag } from 'lucide-react';
import api from '../lib/api';

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/events').then(r => setEvents(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><div className="spin-gold w-8 h-8" /></div>;

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-8 fade-in" data-testid="events-page">
      <h1 className="text-3xl sm:text-4xl font-light tracking-tight mb-2" style={{ fontFamily: 'Outfit' }}>Evenements</h1>
      <p className="text-[#A1A1AA] mb-8">Decouvrez nos prochains evenements</p>

      {events.length === 0 ? (
        <div className="text-center py-20 text-[#A1A1AA]">Aucun evenement a venir pour le moment</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map(evt => (
            <Link key={evt.event_id} to={`/events/${evt.event_id}`} data-testid={`event-card-${evt.event_id}`}
              className="card-hover bg-[#121212] border border-white/5 rounded-2xl overflow-hidden block">
              <div className="overflow-hidden relative" style={{ minHeight: '200px' }}>
                {evt.image_url ? (
                  <img src={evt.image_url} alt={evt.title} className="w-full object-contain" style={{ maxHeight: '300px' }} />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-[#D4AF37]/10 to-transparent flex items-center justify-center">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-[#D4AF37]" style={{ fontFamily: 'Outfit' }}>{new Date(evt.date).getDate()}</div>
                      <div className="text-sm text-[#A1A1AA]">{new Date(evt.date).toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' })}</div>
                    </div>
                  </div>
                )}
                {evt.image_url && (
                  <div className="absolute inset-0 bg-gradient-to-t from-[#121212] to-transparent" />
                )}
                {evt.ticket_url && <div className="absolute top-2 right-2 bg-[#D4AF37] text-black text-[9px] font-bold px-2 py-0.5 rounded-full">Billetterie</div>}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Outfit' }}>{evt.title}</h3>
                <p className="text-sm text-[#A1A1AA] line-clamp-2 mb-4">{evt.description}</p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-xs text-[#A1A1AA]">
                    <MapPin className="w-3.5 h-3.5" /> {evt.location}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-[#A1A1AA]">
                    <Clock className="w-3.5 h-3.5" />
                    {new Date(evt.date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                  <div className="flex items-center justify-between mt-3 pt-3 border-t border-white/5">
                    {evt.tags?.length > 0 && (
                      <div className="flex gap-1">
                        {evt.tags.slice(0, 2).map(t => (
                          <span key={t} className="flex items-center gap-1 text-[10px] bg-[#D4AF37]/10 text-[#D4AF37] px-2 py-0.5 rounded-full">
                            <Tag className="w-2.5 h-2.5" />{t}
                          </span>
                        ))}
                      </div>
                    )}
                    {evt.price > 0 ? (
                      <span className="text-sm font-semibold text-[#D4AF37]">{evt.price.toFixed(2)} EUR</span>
                    ) : (
                      <span className="text-xs text-[#10B981] font-medium">Gratuit</span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
